module.exports = __webpack_public_path__ + "static/img/2webtransfer.eb6b2276.png";